import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from '../../components/Modal/Modal';
import styles from './AboutModal.module.scss';
import { withPrefix } from 'gatsby-link';

export default class AboutModal extends Component {
  render() {
    const { isOpen, handleClose, projects, image } = this.props;

    return (
      <Modal isOpen={isOpen} handleClose={handleClose}>
        <div className={styles.about}>
          <div className={styles.column}>
            <h2 className={styles.aboutHeader}>ABOUT</h2>
    		    <p>
              Type@Cooper West is a year-long program that dives into the highly comprehensive study of techniques, technology, aesthetics, expression, history and theory behind typeface design with the Continuing Education Department of The Cooper Union, in partnership with the Letterform Archive in San Francisco, CA. For the 2017-2018 academic year, 14 students worked intensively under the guidance of main instructors James Edmondson, Frank Greißhammer, Tânia Raposo, Grendl Löfkvist and many other experts as visiting faculty. The first term included introduction to calligraphic roots, study of established typographical conventions, and the creation of typeface revivals. In the second term, students focused on the conception and execution of original typefaces and expanded upon them in the third. This website exhibits all of the work from the second and third semesters. For more information, please visit the <a href="http://coopertype.org">Type@Cooper website</a>.
            </p>
          </div>

          <div className={styles.column}>
            <h2 className={styles.aboutHeader}>SPECIAL THANKS</h2>
            <p>
                The Type@Cooper West 2018 graduating class would love to
                thank their wonderful instructors: Tânia Raposo, Frank Grießhammer,
                James Edmondson, Grendl Löfkvist, as well as the Letterform
                Archive in San Francisco, CA.
            </p>

            <p>
                This website was designed and built by Mew Ophaswongse,
                Bruce Sullivan, Natalie Uduwela and Kris Mendoza.
                Logo design and branding by Kel Troughton and Tommi Sharp.
            </p>

            <p>
                The typeface used throughout the site is Input Mono
                by <span className={styles.mediumItalic}>David Johnathan Ross</span>.
            </p>

            <img src={withPrefix('/groupPic.jpg')} className={styles.aboutImg} alt="Group Picture"/>

          </div>
        	<div className={styles.column}>
        	</div>
        </div>
      </Modal>
    );
  }
};

AboutModal.propTypes = {
  isOpen: PropTypes.bool,
  handleClose: PropTypes.func,
  image: PropTypes.object
};



// WEBPACK FOOTER //
// ./src/components/AboutModal/AboutModal.jsx